import React from 'react'

function AboutPageBreadcrumb() {
    return (
        <div className="about-page-breadcrumb">
            <div className="container">
                <h1 className="about-page-breadcrumb__title">About Us</h1>
            </div>
        </div>
    )
}

export default AboutPageBreadcrumb
